<template>
  <topHeader />
  <div class="faw-container">
    <div class="container">
      <!-- 面包屑导航 -->
      <div class="breadcrumb">
        <span class="breadcrumb-text" @click="goToHome">首页</span>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-current">技术规范</span>
      </div>
      
      <!-- 搜索 -->
      <div class="search-section">
        <div class="search-container">
          <div class="search-box">
            <input 
              type="text" 
              v-model="searchKeyword" 
              placeholder="请输入关键词搜索..." 
              class="search-input"
              @keyup.enter="performSearch"
            />
            <button class="search-btn" @click="performSearch">
              <span class="iconfont icon-sousuo"></span>
              搜索
            </button>
          </div>
          <div class="search-filters">
            <!-- 来源筛选 -->
            <!-- <div 
              class="filter-item"
              @mouseleave="hideAllDropdowns"
            >
              <span 
                class="filter-label"
                @mouseenter="showDropdown('source')"
              >
                来源：
                <span class="current-value">{{ getSourceLabel(selectedSource) }}</span>
                <span class="iconfont icon-xiangyou3" style="font-size: 12px; margin-left: 5px;"></span>
              </span>
              <div 
                class="filter-dropdown" 
                v-show="showSourceDropdown"
              >
                <span 
                  :class="['filter-option', { active: selectedSource === '' }]"
                  @click="handleSourceChange('')"
                >
                  全部来源
                </span>
                <span 
                  v-for="source in sourceOptions" 
                  :key="source"
                  :class="['filter-option', { active: selectedSource === source }]"
                  @click="handleSourceChange(source)"
                >
                  {{ source }}
                </span>
              </div>
            </div> -->
            
            <!-- 年份筛选 -->
            <div 
              class="filter-item"
              @mouseleave="hideAllDropdowns"
            >
              <span 
                class="filter-label"
                @mouseenter="showDropdown('year')"
              >
                年份：
                <span class="current-value">{{ getYearLabel(selectedYear) }}</span>
                <span class="iconfont icon-xiangyou3" style="font-size: 12px; margin-left: 5px;"></span>
              </span>
              <div 
                class="filter-dropdown" 
                v-show="showYearDropdown"
              >
                <span 
                  :class="['filter-option', { active: selectedYear === '' }]"
                  @click="handleYearChange('')"
                >
                  全部年份
                </span>
                <span 
                  v-for="year in yearOptions" 
                  :key="year"
                  :class="['filter-option', { active: selectedYear === year }]"
                  @click="handleYearChange(year)"
                >
                  {{ year }}年
                </span>
              </div>
            </div>
            
            <button class="reset-btn" @click="resetSearch">重置</button>
          </div>
        </div>
      </div>
      
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <div class="loading-text">加载中...</div>
      </div>
      
      <!-- 技术规范列表 -->
      <div class="faw-section" v-else>
        <h2 class="faw-title">技术规范</h2>
        <div class="faw-list" v-if="techList.length > 0">
          <div class="faw-item" v-for="(item, index) in techList" :key="item.id || index" @click="goToDetail(item)">
            <span class="faw-bullet">•</span>
            <span class="faw-name">{{ item.name }}</span>
            <button class="faw-view-btn" @click.stop="goToDetail(item)">查看</button>
          </div>
        </div>
        <div v-else class="empty-list">
          <p>暂无数据</p>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination" v-if="!loading && techList.length > 0">
        <button class="page-btn" :disabled="currentPage === 1 || loading" @click="prevPage">上一页</button>
        <span class="page-info">{{ currentPage }} / {{ totalPages || 1 }}</span>
        <button class="page-btn" :disabled="currentPage === totalPages || loading" @click="nextPage">下一页</button>
      </div>
    </div>
  </div>
  <Footer />
</template>
  <script>
import topHeader from './top-Header.vue';
import Footer from './Footer.vue';
import { getConsultInfoList, getConsultSource } from '@/api'

export default {
  name: "TechSpecPage",
  components: {
    topHeader,
    Footer
  },
  data() {
    return {
      techList: [],
      currentPage: 1,
      itemsPerPage: 20,
      total: 0,
      loading: false,
      searchKeyword: '',
      selectedSource: '',
      selectedYear: '',
      // 控制下拉显示
      showSourceDropdown: false,
      showYearDropdown: false,
      // 筛选选项
      sourceOptions: [],
      yearOptions: []
    }
  },
  mounted() {
    this.fetchSourceList()
    this.fetchYearOptions()
    this.fetchList()
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.itemsPerPage);
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
    goToDetail(item) {
      if (item && item.id) {
        this.$router.push({
          path: '/techSpecDetail',
          query: { id: item.id }
        })
      }
    },
    async fetchList() {
      this.loading = true
      try {
        const params = {
          type: '2', // 2技术规范
          pageNum: String(this.currentPage),
          pageSize: String(this.itemsPerPage)
        }
        
        // 添加可选参数
        if (this.searchKeyword) {
          params.keyword = this.searchKeyword
        }
        if (this.selectedSource) {
          params.source = this.selectedSource
        }
        if (this.selectedYear) {
          params.year = this.selectedYear
        }
        
        const res = await getConsultInfoList(params)
        
        // 处理返回数据
        const list = (res && res.rows) || res?.data?.rows || res?.data || []
        this.techList = (list || []).map(item => ({
          id: item.id,
          name: item.title || item.name || '未命名'
        }))
        
        // 设置总数
        this.total = res?.total || res?.data?.total || this.techList.length
      } catch (error) {
        console.error('获取技术规范列表失败:', error)
        this.techList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    
    // 获取来源列表
    async fetchSourceList() {
      try {
        const res = await getConsultSource({ type: '2' })
        // 处理返回数据，支持多种数据结构
        let sources = []
        if (res && res.data) {
          sources = Array.isArray(res.data) ? res.data : []
        } else if (Array.isArray(res)) {
          sources = res
        } else if (res && res.rows) {
          sources = Array.isArray(res.rows) ? res.rows : []
        }
        
        // 如果返回的是对象数组，提取source字段或name字段
        if (sources.length > 0 && typeof sources[0] === 'object') {
          this.sourceOptions = sources.map(item => item.source || item.name || item).filter(Boolean)
        } else {
          // 如果返回的是字符串数组，直接使用
          this.sourceOptions = sources.filter(Boolean)
        }
      } catch (error) {
        console.error('获取来源列表失败:', error)
        this.sourceOptions = []
      }
    },
    
    // 生成年份选项（最近5年）
    fetchYearOptions() {
      const currentYear = new Date().getFullYear()
      this.yearOptions = []
      for (let i = 0; i < 5; i++) {
        this.yearOptions.push(String(currentYear - i))
      }
    },
    
    performSearch() {
      this.currentPage = 1 // 重置到第一页
      this.fetchList()
    },
    
    resetSearch() {
      this.searchKeyword = '';
      this.selectedSource = '';
      this.selectedYear = '';
      this.currentPage = 1;
      this.fetchList()
    },
    
    // 控制下拉框显示
    showDropdown(type) {
      this.showSourceDropdown = false;
      this.showYearDropdown = false;
      
      switch(type) {
        case 'source':
          this.showSourceDropdown = true;
          break;
        case 'year':
          this.showYearDropdown = true;
          break;
      }
    },
    
    hideAllDropdowns() {
      this.showSourceDropdown = false;
      this.showYearDropdown = false;
    },
    
    // 处理选择
    handleSourceChange(value) {
      this.selectedSource = value;
      this.hideAllDropdowns();
      this.performSearch();
    },
    
    handleYearChange(value) {
      this.selectedYear = value;
      this.hideAllDropdowns();
      this.performSearch();
    },
    
    // 获取标签显示文本
    getSourceLabel(value) {
      return value || '全部来源';
    },
    
    getYearLabel(value) {
      return value ? `${value}年` : '全部年份';
    },
    
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchList()
        // 滚动到顶部
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchList()
        // 滚动到顶部
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #f5f5f5;
  min-height: 100vh;
}

/* 面包屑导航 */
.breadcrumb {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
  padding: 15px 0;
  text-align: left;
}

.breadcrumb-text {
  color: #422C27;
  cursor: pointer;
  transition: color 0.3s ease;
}

.breadcrumb-text:hover {
  color: #422C27;
}

.breadcrumb-separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-current {
  color: #333;
  font-weight: bold;
}

/* 技术规范标题 */
.faw-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  text-align: left;
  padding-left: 10px;
  border-left: 4px solid #422C27;
}

/* 技术规范列表区域 */
.faw-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  padding: 20px;
  margin-bottom: 20px;
}

/* 列表样式 */
.faw-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.faw-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  margin: 8px 0;
  border-radius: 8px;
  border-left: 4px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
  background: #f8f9fa;
}

.faw-item:last-child {
  margin-bottom: 0;
}

.faw-item:hover {
  background: linear-gradient(to right, #E4CEC2 0%, #ffffff 100%);
  border-left-color: #422C27;
  box-shadow: 0 4px 15px #d6bfba;
  transform: translateX(5px);
  padding-left: 25px;
}

/* 项目符号 */
.faw-bullet {
  color: #422C27;
  font-size: 16px;
  margin-right: 12px;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

.faw-item:hover .faw-bullet {
  color: #422C27;
  transform: scale(1.3);
}

/* 技术规范名称 */
.faw-name {
  flex: 1;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
  margin-right: 20px;
  transition: color 0.3s ease;
}

.faw-item:hover .faw-name {
  color: #422C27;
  font-weight: 500;
}

/* 查看按钮 */
.faw-view-btn {
  height: 36px;
  padding: 0 16px;
  background: #422C27;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.faw-view-btn:hover {
  background: #E4CEC2;
  color: #333;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px #ad9b91;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    padding: 10px;
  }
  
  .faw-item {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px;
  }
  
  .faw-bullet {
    margin-right: 8px;
    margin-bottom: 5px;
  }
  
  .faw-name {
    margin-right: 0;
    margin-bottom: 10px;
    width: 100%;
  }
  
  .faw-view-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .faw-title {
    font-size: 20px;
  }
  
  .faw-item {
    padding: 12px;
  }
  
  .faw-name {
    font-size: 14px;
  }
  
  .breadcrumb {
    font-size: 12px;
  }
}

/* 加载状态 */
.loading-container {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.loading-text {
  font-size: 16px;
  color: #666;
}

/* 空列表 */
.empty-list {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.empty-list p {
  font-size: 16px;
  color: #999;
  margin: 0;
}

/* 搜索区域 */
.search-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-bottom: 20px;
  padding: 20px;
}

.search-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.search-box {
  display: flex;
  gap: 10px;
  align-items: center;
}

.search-input {
  flex: 1;
  height: 40px;
  padding: 0 15px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s ease;
}

.search-input:focus {
  border-color: #422C27;
}

.search-btn {
  height: 40px;
  padding: 0 20px;
  background: #422C27;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s ease;
}

.search-btn:hover {
  background: #E4CEC2;
  color: #333;
}

.search-filters {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
}

/* 筛选项容器 */
.filter-item {
  position: relative;
  display: inline-block;
}

/* 筛选标签 */
.filter-label {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: all 0.3s;
  user-select: none;
}

.filter-label:hover {
  background: #E4CEC2;
  color: #333;
}

.filter-label .current-value {
  color: #422C27;
  margin-left: 5px;
  font-weight: 500;
}

/* 下拉选项容器 */
.filter-dropdown {
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 100;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  background: white;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  margin-top: 2px;
  min-width: 300px;
  max-width: 600px;
  border: 1px solid #f0f0f0;
}

/* 下拉选项 */
.filter-option {
  display: inline-block;
  padding: 6px 18px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  color: #666;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.filter-option:hover {
  color: #333;
  background: #E4CEC2;
  transform: translateY(-2px);
  box-shadow: 0 2px 6px rgba(14, 133, 117, 0.2);
}

.filter-option.active {
  border-color: #422C27;
  background: #422C27;
  color: white;
  font-weight: 500;
}

.reset-btn {
  height: 36px;
  padding: 0 16px;
  background: #f8f9fa;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.reset-btn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-top: 20px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-btn:hover:not(:disabled) {
  background: #422C27;
  color: white;
  border-color: #422C27;
}

.page-info {
  font-size: 14px;
  color: #666;
}
</style>